import React from 'react';
import { useSelector } from 'react-redux';
import { Card, Popup, Image, Responsive } from 'semantic-ui-react';
import { getAssets } from '../../selectors';
import i18next from 'i18next';
import { attachCurrency } from '../general/CurrencyFormat';
import OpeningHours from './OpeningHours';

import './BranchCard.scss';

const BranchCard = (props) => {
    const branch = useSelector(state => state.business.branch);
    const tableNumber = useSelector(state => state.order.tableNumber);
    const orderType = useSelector(state => state.order.cart.orderType);
    const { logo } = useSelector(getAssets);

    const renderDesc = () => {
        if (orderType === 'delivery') {
            const { orderFee, minimumOrderPrice, estimatedTime } = branch.deliveryAreas[0] || {};

            return (
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: 13 }}>
                    <div style={{ textAlign: 'center' }}>
                        {i18next.t('business.deliveyFee')}
                        <br />
                        <b style={{ fontSize: 16 }}>{attachCurrency(orderFee || 0)}</b>
                    </div>
                    <div style={{ textAlign: 'center' }}>
                        {i18next.t('business.orderMinimum')}
                        <br />
                        <b style={{ fontSize: 16 }}>{attachCurrency(minimumOrderPrice || 0)}</b>
                    </div>
                    <div style={{ textAlign: 'center' }}>
                        {i18next.t('business.estimatedTime')}
                        <br />
                        <b style={{ fontSize: 16 }}>{`${estimatedTime} ${i18next.t('general.minutes')}`}</b>
                    </div>
                </div>
            );
        }

        return i18next.t('orderTypes.' + orderType, { tableNumber, context: tableNumber ? 'table' : null });
    };


    if (!branch) {
        return null;
    }

    return (
        <Card fluid style={{ marginTop: 10 }} className="pi branch-card">
            <Card.Content>
                <Card.Header className="pi branch-card-header">
                    {branch.name}
                    <Image src={logo} className="logo-img" />
                    <Responsive minWidth={769}>
                        <Popup trigger={<Image src="calendar.png" className="calendar-img"/>} position="bottom left" flowing>
                            <Popup.Content>
                                <OpeningHours availabilityHours={(orderType === 'delivery' && branch.deliveryHours) || branch.openingHours}/>
                            </Popup.Content>
                        </Popup>
                    </Responsive>
                </Card.Header>
                <Card.Meta>{branch.address}</Card.Meta>
                <Card.Meta>{branch.phone}</Card.Meta>
                <Card.Description>
                    {renderDesc()}
                </Card.Description>
                <Responsive maxWidth={768} style={{ marginTop: 20 }}>
                    <OpeningHours availabilityHours={(orderType === 'delivery' && branch.deliveryHours) || branch.openingHours}/>
                </Responsive>
            </Card.Content>
        </Card>
    );
};

export default BranchCard;
